<template>
    <main ref="scrollComponent" class="mx-auto">
        <section v-if="getLoadingAula">
            <div class="h-4 bg-gray-200 rounded-full tracking-wider w-1/2 mx-4 mt-4 mb-1"></div>
            <Carousel v-bind="settings" :breakpoints="breakpoints">
                <slide v-for="(loading, index) in 6" :key="index">
                    <VideoSkeleton />
                </slide>
            </Carousel>
        </section>
        <section v-else-if="getAulasAssistidas.length">
            <h1 class="text-primary md:text-xl font-bold text-left tracking-wider px-3 pb-1 dark:text-secondary">
                Assistidos Recentemente
            </h1>
            <Carousel v-bind="settings" :breakpoints="breakpoints">
                <slide v-for="aula in getAulasAssistidas" :key="aula.id">
                    <router-link :to="'/aula/' + aula.id" class="px-2 w-full">
                        <SingleVideoComponent class="mx-auto md:mx-0" :aula="aula" />
                    </router-link>
                </slide>
                <template #addons>
                    <Navigation />
                </template>
            </Carousel>
        </section>
    </main>
</template>
<script>
    import SingleVideoComponent from '@/components/SingleVideoComponent.vue';
    import VideoSkeleton from '@/components/VideoSkeletonComponent.vue';
    import { Carousel, Slide, Navigation } from 'vue3-carousel'
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'CarouselVideosComponent',
        data: () => ({
            settings: {
                itemsToShow: 1.1,
                snapAlign: 'center',
            },
            breakpoints: {
                580: {
                    itemsToShow: 1.8,
                    snapAlign: 'start',
                },
                700: {
                    itemsToShow: 2.2,
                    snapAlign: 'start',
                },
                880: {
                    itemsToShow: 2.5,
                    snapAlign: 'start',
                },
                1000: {
                    itemsToShow: 2.8,
                    snapAlign: 'start',
                },
                1200: {
                    itemsToShow: 3.2,
                    snapAlign: 'start',
                },
                1440: {
                    itemsToShow: 4.2,
                    snapAlign: 'start',
                },
                1800: {
                    itemsToShow: 5.2,
                    snapAlign: 'start',
                },
                2560: {
                    itemsToShow: 6.2,
                    snapAlign: 'start',
                }
            },
        }),
        components: {
            SingleVideoComponent,
            VideoSkeleton,
            Carousel,
            Slide,
            Navigation
        },
        methods:{
            ...mapActions(['fetchVideosAssistidos'])
        },
        computed:{
            ...mapGetters(['getLoadingAula', 'getAulasAssistidas']),
        },
        mounted(){
            this.fetchVideosAssistidos();
        }
    }
</script>
<style >
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}



.carousel__prev,
.carousel__next {
  height: 100%!important;
  width: 50px!important;
  margin: 0!important;
  box-sizing: content-box;
  /* background-color: white; */
}
.carousel__next--disabled, 
.carousel__prev--disabled {
    display: none!important;
    opacity: 0!important;
}
.carousel__icon{
    color: white;
    background-color: rgba(0,0,0,.3);
  }
</style>